@let blogCategories = categories();

<section class="s1-categories-list--list">
    @for (category of blogCategories?.data?.stories; track category.full_slug) {
        <s1-blog-categories-preview [block]="category" [titleLevel]="block().titleLevel"
                                    class="s1-categories-list--item"/>
    }
</section>
